import { css as n, styled as e } from "styled-components";
import { Theme as t, DarkThemeQuery as x, DarkNinjaThemeQuery as h } from "../../styles/themes/index.js";
import { Colors as i } from "../../styles/colors/index.js";
import { CaptionHeavy as m, SmallLight as p, H3Heavy as b, H2Heavy as f, SmallHeavy as l } from "../../styles/typography/index.js";
import { clampMixin as s } from "../../styles/shared/index.js";
import { Skeleton as a } from "../Skeleton/index.js";
import { TextSkeleton as o } from "../TextSkeleton/index.js";
import { MediaQuery as r } from "../../styles/variables.js";
const d = n`
  position: relative;
  background-color: rgb(${t.colors.Juliet});
  border: 1px solid rgb(${t.colors.Golf});
  border-radius: 16px;
`, H = e.div`
  ${d}
  width: 100%;
  padding: 16px;
  display: grid;
  justify-content: start;
  grid-template-areas:
    'image title'
    'image price'
    'image stores';
  column-gap: 12px;
  row-gap: 8px;

  .hot-tag {
    left: 24px;
  }

  .title {
    height: unset;
  }

  .gradient-border {
    left: 16px;
  }

  && .image {
    width: 112px;
    height: 112px;
  }

  @media ${r.SCREEN_MD_UP} {
    padding: 16px 24px;
    width: 192px;
    height: 316px;
    display: flex;
    flex-direction: column;
    justify-content: unset;
    row-gap: 8px;

    && .image {
      width: 132px;
      height: 132px;
    }

    .hot-tag,
    .gradient-border {
      left: unset;
    }

    .title {
      height: 54px;
    }
  }
`, P = e.div`
  ${d}
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 16px 24px;
  width: 192px;
  height: 316px;
`, c = n`
  width: 132px;
  height: 132px;
  border-radius: 8px;
  border: 1px solid rgb(${t.colors.Golf});
  align-self: center;
  grid-area: image;
`, j = e.div`
  ${c}
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(${i.White});

  picture {
    width: 82px;
    height: 82px;
  }

  img {
    width: 82px;
    height: 82px;
    object-fit: contain;
  }
`, B = e.div`
  height: 54px;
  grid-area: title;

  & > :first-child {
    ${m}

    // lineHeight same as CaptionHeavy
    ${s(3, 1.125)}
  }
`, M = e.div`
  display: flex;
  flex-direction: column;
  width: 142px;
  height: max-content;
  grid-area: price;
  ${p}
`, T = e.div`
  color: rgb(${t.colors.Brand});

  ${b}

  span {
    ${f}
  }

  // lineHeight same as H2Heavy
  ${s(1, 2)}
`, g = n`
  ${p}
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgb(${i.Gray});
  width: 100%;

  ${x} {
    color: rgb(${i.Porcelain});
  }

  ${h} {
    color: rgb(${i.Ice});
  }
`, E = e.div`
  ${g}
  div {
    display: flex;
    flex-direction: column;
  }
`, _ = e.div`
  ${g}
  grid-area: stores;

  .icon-container,
  .stores-count-text {
    display: none;
  }

  @media ${r.SCREEN_MD_UP} {
    .icon-container,
    .stores-count-text {
      display: flex;
      flex-direction: column;
    }
  }
`, D = e.div`
  ${l}
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgb(${t.colors.Brand});
  color: rgb(${i.Porcelain});
  padding: 8px 20px;
  border-radius: 100px;
  margin-top: 4px;
  white-space: nowrap;

  i {
    font-size: 20px;
  }

  @media ${r.SCREEN_MD_UP} {
    display: none;
  }
`, G = e(a)`
  && {
    width: 100%;
    max-width: 194px;
    height: 32px;
    border-radius: 100px;
    margin-top: 4px;

    @media ${r.SCREEN_MD_UP} {
      display: none;
    }
  }
`, I = e.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgb(${t.colors.Golf});
  background-color: rgb(${t.colors.Mike});

  i {
    color: rgb(${t.colors.Brand});
    font-size: 16px;
  }
`, N = e.div`
  ${l}
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  background-color: rgb(${i.Salmon});
  color: rgb(${t.colors.Brand});
  padding-right: 8px;
  padding-left: 4px;
  border-radius: 8px;
  position: absolute;
  top: -10px;
  height: 20px;

  i {
    font-size: 16px;
  }
`, W = e.div`
  position: absolute;
  width: 142px;
  height: 1px;
  top: -1px;

  background: linear-gradient(
    90deg,
    rgba(${t.colors.Brand}, 0) 1.56%,
    rgb(${t.colors.Brand}) 50.75%,
    rgba(${t.colors.Brand}, 0) 100%
  );
`, R = e(a)`
  && {
    ${c}
  }
`, U = e(o)`
  && {
    height: 14px;
    width: 132px;

    &:last-of-type {
      width: 112px;
    }
  }
`, z = e(o)`
  && {
    height: 12px;
    width: 54px;
    margin-bottom: 4px;
  }
`, Q = e(o)`
  && {
    height: 24px;
    width: 102px;
  }
`, V = e(o)`
  && {
    height: 12px;
    width: 82px;
    margin-bottom: 2px;
  }
`, J = e(o)`
  && {
    height: 12px;
    width: 42px;
  }
`, L = e(a)`
  && {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
`;
export {
  P as Container,
  H as ContainerV2,
  W as GradientBorder,
  N as HotTag,
  I as IconContainer,
  L as IconSkeleton,
  R as ImageSkeleton,
  j as ImageWrapper,
  D as MobileStoresCount,
  G as MobileStoresCountSkeleton,
  T as PriceContainer,
  Q as PriceSkeleton,
  z as PriceTitleSkeleton,
  M as PriceWrapper,
  E as StoresContainer,
  _ as StoresContainerV2,
  J as StoresSkeleton,
  V as StoresTitleSkeleton,
  U as TitleSkeleton,
  B as TitleWrapper
};
